import React from 'react';
import moment from 'moment';

interface MonthNavigatorProps {
  selectedYear: number;
  selectedMonth: number;
  onChange: (year: number, month: number) => void;
  extraControls?: React.ReactNode;
}

const MonthNavigator: React.FC<MonthNavigatorProps> = ({ selectedYear, selectedMonth, onChange, extraControls }) => {
  const currentYear = moment().year();
  const currentMonth = moment().month();

  const yearOptions = Array.from({ length: 10 }, (_, i) => currentYear - 5 + i);
  const isFutureMonth = (year: number, month: number) => {
    return year > currentYear || (year === currentYear && month > currentMonth);
  };

  const sharedSelectClass =
    'border bg-white rounded-md px-4 py-2 text-gray-700 text-sm font-medium shadow-sm transition-all';

  return (
    <div className="flex items-center gap-3">
      {extraControls && <div className="ml-2">{extraControls}</div>}

      <select
        value={selectedYear}
        onChange={(e) => onChange(Number(e.target.value), selectedMonth)}
        className={sharedSelectClass}
      >
        {yearOptions.map((year) => (
          <option key={year} value={year} disabled={year > currentYear}>
            {year}
          </option>
        ))}
      </select>

      <select
        value={selectedMonth}
        onChange={(e) => onChange(selectedYear, Number(e.target.value))}
        className={sharedSelectClass}
      >
        {moment.months().map((month, idx) => (
          <option key={month} value={idx} disabled={isFutureMonth(selectedYear, idx)}>
            {month}
          </option>
        ))}
      </select>
    </div>
  );
};

export default MonthNavigator; 